import {
  ListButton,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as CardActionCheckboxProps } from "components/Cards/Card/Actions/Checkbox"
import { Props as CardLoadMoreCheckboxProps } from "components/Cards/Card/Actions/LoadMore"

import Actions from "./Actions"

export interface Props {
  clearListButtonProps: ListButton
  isAdmin: boolean
  isEditor: boolean
  listButtonProps: ListButton
  loadMoreProps: CardLoadMoreCheckboxProps
  onlyNewProps: CardActionCheckboxProps
  onlyPresentProps: CardActionCheckboxProps
  serviceName: ReviewsServiceName
  showFlaggedProps: CardActionCheckboxProps
}

export interface ComponentProps extends Props {}

export default Actions
